import styled from 'styled-components';
import { StructuredText } from 'react-datocms';
import type { Document } from 'datocms-structured-text-utils';
import { customNodeRules } from '@/components/structuredText';
import type { NumberedItemFragment } from '@/utils/dato/generated';

interface CircleProps {
  backgroundColor?: string;
  textColor?: string;
}

const Circle = styled.div<CircleProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-weight: bold;
  color: ${({ textColor = '#0E2C27' }) => textColor};
  width: 80px;
  height: 80px;
  text-align: center;
  background: ${({ backgroundColor = '#FFFFFF' }) => backgroundColor};
  border-radius: 999px;
`;

const NumberedItem = ({ content, number }: NumberedItemFragment) => (
  <div className="mt-6">
    <Circle className="mb-6">{number}</Circle>
    {content ? <StructuredText data={{ value: content.value as Document }} customNodeRules={customNodeRules} /> : null}
  </div>
);

export default NumberedItem;
